import axios from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import Yup from 'yup';
import ModalAbstraction from '../../CallToAction/LeftRailCTA/ModalAbstraction/ModalAbstraction';
import PopUp from '../../Elements/PopUp/PopUp';
import BasicDropdown from '../../Input/BasicDropdown/BasicDropdown';
import Button from '../../Input/Button/Button';
import TextAreaInput from '../../Input/TextAreaInput/TextAreaInput';

import './FlexibilityTipModal.scss';

const schemas = {
    companyId: Yup.number().required(),
    fieldName: Yup.string()
        .nullable()
        .oneOf(['work_from_home', 'part_time', 'flexible']),
    comment: Yup.string().nullable().max(5000),
    atLeastOneField: Yup.mixed().when(['fieldName', 'comment'], {
        is: (fieldName, comment) => !fieldName && !comment,
        then: Yup.string().test(
            'at-least-one',
            'Please fill out at least one of these fields.',
            () => false
        ),
        otherwise: Yup.string().test(
            'at-least-one',
            'Please fill out at least one of these fields.',
            () => true
        ),
    }),
};

export default class FlexibilityTipModal extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            fieldName: null,
            comment: null,
            errors: {
                companyId: null,
                fieldName: null,
                comment: null,
                atLeastOneField: null,
            },
            generalError: null,
            showPopUp: false,
            popUpMessage: null,
        };
    }

    static propTypes = {
        companyId: PropTypes.number.isRequired,
        companyName: PropTypes.string.isRequired,
        jobTypes: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                value: PropTypes.type,
            })
        ),
        onClose: PropTypes.func.isRequired,
        showModal: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        jobTypes: [
            {
                label: 'Remote Jobs',
                value: 'work_from_home',
            },
            {
                label: 'Part-Time Jobs',
                value: 'part_time',
            },
            {
                label: 'Flexible Schedule Available',
                value: 'flexible',
            },
        ],
    };

    _validateInput = async (type, value) => {
        try {
            await schemas[type].validate(value);
            return true;
        } catch (e) {
            const errors = { ...this.state.errors };
            errors[type] = e.message;
            this.setState({
                errors,
            });
            return false;
        }
    };

    handleInputChange = (type) => (value) => {
        const newState = { ...this.state };
        const newValue = value || null;
        newState[type] = newValue;
        newState.errors[type] = null;
        newState.generalError = null;
        this.setState(newState, () => this._validateInput(type, newValue));
    };

    handleClose = () => {
        this.setState({ showPopUp: false }, this.props.onClose);
    };

    onSubmitTipForm = async () => {
        try {
            await axios.post('/api/company/submit-flexibility-tip', {
                companyId: this.props.companyId,
                fieldName: this.state.fieldName,
                comment: this.state.comment,
            });

            this.setState({
                showPopUp: true,
                popUpMessage:
                    "Thanks for the tip. We'll review and post content that meets guidelines shortly.",
            });
        } catch (e) {
            const errors = e.response.data.errors;
            const errorMessage = errors[Object.keys(errors)[0]];

            this.setState({
                showPopUp: true,
                popUpMessage: errorMessage,
            });
        }
    };

    renderInputFields = () => {
        return (
            <div className="input-comment-section">
                <div className="pt-3">
                    <BasicDropdown
                        options={this.props.jobTypes}
                        onChange={this.handleInputChange('fieldName')}
                        selectedValue={this.state.fieldName}
                        defaultLabel={'What type of jobs are offered?'}
                        shouldDisableDefault={true}
                    />
                </div>
                <div className="pt-3">
                    <TextAreaInput
                        name="comment"
                        qaDataAttr={'comment-box'}
                        onChange={this.handleInputChange('comment')}
                        onBlur={() =>
                            this._validateInput('comment', this.state.comment)
                        }
                        value={this.state.comment}
                        border={{ border: '1px solid grey' }}
                        placeholder={`What else would you say about flexibility policies at this employer? What departments are best for flexible work, for example?`}
                    />
                </div>
                <div className="errorMessage">{this.state.errors.comment}</div>
            </div>
        );
    };

    renderForm = () => {
        const { fieldName, comment, errors, generalError } = this.state;
        let noErrors = true,
            submitButtonDisabled = true;
        if (generalError) {
            noErrors = false;
        }
        for (let type in errors) {
            if (errors[type]) {
                noErrors = false;
                break;
            }
        }

        if (noErrors && (fieldName || comment)) {
            submitButtonDisabled = false;
        }

        return (
            <div className={'flexibility-tip-form'}>
                <form>{this.renderInputFields()}</form>
                <div className="submit-button-div">
                    <Button
                        disabled={submitButtonDisabled}
                        type={'solid'}
                        value={'Add a tip'}
                        onClick={this.onSubmitTipForm}
                    />
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="component-Employer-FlexibilityTipModal ">
                <ModalAbstraction
                    showModal={this.props.showModal}
                    onClose={this.props.onClose}
                    allowScroll={false}
                    showButton={false}
                    title={`ADD A TIP FOR ${this.props.companyName.toUpperCase()}!`}
                >
                    {this.renderForm()}
                </ModalAbstraction>
                <PopUp
                    showPopUp={this.state.showPopUp}
                    showOverlay={true}
                    close={this.handleClose}
                    cancel={() => this.setState({ showPopUp: false })}
                    buttonText={'Continue'}
                    minHeight={'300px'}
                    minWidth={'320px'}
                    maxHeight={'300px'}
                    maxWidth={'320px'}
                >
                    <p>{this.state.popUpMessage}</p>
                </PopUp>
            </div>
        );
    }
}
